import i18n, { Resource } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { DateTime } from 'luxon';
import { initReactI18next } from 'react-i18next';

import { ApplicationLocalization } from './application.i18n';
import { Languages } from './languages';

const resources: Resource = {
  [Languages.Norwegian]: {},
  [Languages.English]: {},
};

for (const [key, value] of Object.entries(ApplicationLocalization)) {
  resources[Languages.English][key] = value[Languages.English];
  resources[Languages.Norwegian][key] = value[Languages.Norwegian];
}

export const defaultNS = 'common';

export const i18nInstance = i18n.use(initReactI18next).use(LanguageDetector);
const debug = false; //import.meta.env.VITE_I18N_DEBUG;

// Derive namespaces from ApplicationLocalization to keep them in sync
const namespaces = Object.keys(ApplicationLocalization);

i18nInstance.init({
  debug: debug,
  ns: namespaces,
  defaultNS,
  fallbackLng: Object.values(Languages),

  interpolation: {
    escapeValue: false,
    skipOnVariables: false,
  },
  resources,
});

i18n.services.formatter?.add('DATE_HUGE', (value, lng) => {
  const local =
    lng && Object.values(Languages).includes(lng as Languages) ? lng : Languages.English;
  return DateTime.fromJSDate(value).setLocale(local).toLocaleString(DateTime.DATE_HUGE);
});

i18n.services.formatter?.add('DATETIME_SHORT', (value, lng) => {
  const local =
    lng && Object.values(Languages).includes(lng as Languages) ? lng : Languages.English;
  return DateTime.fromJSDate(value).setLocale(local).toLocaleString(DateTime.DATETIME_SHORT);
});
